// extracted by mini-css-extract-plugin
module.exports = {"form":"PriceBox_form__3CNuc","result":"PriceBox_result__1mYvW","summary":"PriceBox_summary__2X6bN","table":"PriceBox_table__1piuv","total":"PriceBox_total__2CWrE"};